//
//
//
//
//
//
//
//
//
//
//
//

import LogList from "@/components/Query/LogList";
export default {
  name: "CooperativeLogList",
  data() {
    return {};
  },
  components: { LogList },
  created() {},
  mounted() {},
  methods: {},
};
